var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU04 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 341.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-1200.00, 0.00)",
    id: "U4_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1205.26,242.57 C1206.30,236.64 1210.89,222.91 1213.79,217.05 C1216.45,211.71 1224.10,200.11 1230.15,192.10 C1239.20,180.63 1243.86,175.27 1252.17,166.44 C1262.75,155.51 1291.43,127.19 1300.44,118.99 C1308.03,112.45 1318.93,103.80 1324.60,99.96 C1329.52,96.64 1342.39,89.42 1350.53,87.11 C1354.46,86.02 1361.82,85.08 1365.25,85.22 C1368.73,85.40 1374.19,86.77 1378.05,88.30 C1384.67,90.95 1397.97,97.57 1407.12,102.78 C1413.58,106.50 1445.28,128.42 1459.26,138.74 C1466.28,144.11 1479.12,154.67 1484.95,159.85 C1491.21,165.65 1501.57,176.37 1505.15,181.30 C1510.71,189.02 1518.24,203.70 1520.20,210.64 C1523.71,223.30 1534.44,272.83 1536.03,279.80 C1536.81,283.58 1536.66,290.54 1535.73,294.37 C1534.76,298.22 1531.04,306.39 1528.39,310.53 C1524.96,315.84 1514.97,326.68 1509.52,331.73 C1504.75,336.12 1490.77,347.44 1483.48,352.93 C1467.94,363.94 1439.33,382.86 1427.00,390.03 C1419.04,394.51 1401.89,402.22 1394.01,404.65 C1386.67,406.88 1373.21,408.36 1366.45,408.44 C1359.93,408.49 1346.87,407.47 1338.37,405.73 C1331.27,404.27 1315.83,399.96 1308.84,397.49 C1301.32,394.81 1286.88,388.13 1279.31,383.83 C1274.03,380.81 1260.24,370.44 1254.17,365.22 C1247.97,359.87 1236.12,348.26 1231.09,342.26 C1226.02,336.18 1216.84,322.36 1214.24,316.45 C1210.89,308.74 1206.48,293.20 1205.33,285.00 C1203.12,269.00 1204.54,246.75 1205.26,242.57 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU04, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-04.efc8d2c2.svg";
export { ForwardRef as ReactComponent };